import { Tooltip, Typography } from '@mui/material';
import React from 'react';

import WsColors from '../../WsColors';
import { WsColorsNew } from '../../WsEnums/index';

export enum WsTypoVariants {
  TITLE = 'h5',
  SUB_TITLE = 'h6',
  BODY1 = 'body1',
  BODY2 = 'body2',
  CAPTION = 'caption',
  H2 = 'h2',
}

export enum WsTypoColors {
  PRIMARY = 'primary',
  PRIMARY200 = 'primary200',
  PRIMARY600 = 'primary600',
  PRIMARY750 = 'primary750',
  PRIMARY900 = 'primary900',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  TERTIARY50 = 'tertiary50',
  TERTIARY900 = 'tertiary900',
  QUATERNARY = 'quaternary',
  QUINARY = 'quinary',
  SENARY = 'senary',
  BLACK = 'black',
  WHITE = 'white',
  RED = 'red',
  YELLOW = 'yellow',
  ERROR = 'error',
  GREEN = 'green',
  GREYTEXT = 'greytext',
  GREYTEXT2 = 'greytext2',
  FORESTGREEN = 'forestgreen',
  YELLOWDARK = 'yellowdark',
  DARKRED = 'darkred',
  TEXTLIGHT = 'textLight',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
}
export const mapColor = new Map();
mapColor.set('primary', WsColors.TheBlues500);
mapColor.set('primary200', WsColors.TheBlues200);
mapColor.set('primary600', WsColors.TheBlues600);
mapColor.set('primary750', WsColors.TheBlues750);
mapColor.set('primary900', WsColors.TheBlues900);
mapColor.set('secondary', WsColors.TertiaryShades600);
mapColor.set('tertiary', WsColors.TertiaryShades400);
mapColor.set('tertiary50', WsColors.TertiaryShades50);
mapColor.set('tertiary900', WsColors.TertiaryShades900);
mapColor.set('quaternary', WsColors.TertiaryShades500);
mapColor.set('quinary', WsColors.TertiaryShades700);
mapColor.set('senary', WsColors.TertiaryShades800);
mapColor.set('black', WsColors.GenericRichBlack);
mapColor.set('white', WsColors.White);
mapColor.set('yellow', WsColors.Yellow500);
mapColor.set('yellowdark', WsColors.Yellow600);
mapColor.set('error', WsColors.Red400);
mapColor.set('green', WsColors.Green500);
mapColor.set('greytext', WsColors.GreyText);
mapColor.set('gretext2', WsColors.GreyText2);
mapColor.set('red', WsColors.Red);
mapColor.set('forestgreen', WsColors.ForestGreen);
mapColor.set('darkred', WsColors.DarkRed);
mapColor.set('TEXTLIGHT', WsColors.TextLight);
mapColor.set('success', WsColorsNew.success_700);
mapColor.set('neutral', WsColorsNew.neutral_700);

export interface WsTypographyProps {
  children: React.ReactNode;
  variant?: WsTypoVariants;
  onClick?: React.MouseEventHandler;
  color?: WsTypoColors;
  bold?: boolean;
  opacity?: boolean;
  cursor?: 'pointer' | 'text' | 'no-drop' | 'default';
  display?: 'inline' | 'block';
  hoverText?: string;
  className?: string;
  onContextMenu?: React.MouseEventHandler;
}
const WsTypography = ({
  children,
  variant = WsTypoVariants.BODY1,
  onClick,
  color = WsTypoColors.BLACK,
  bold,
  opacity = false,
  cursor,
  display,
  hoverText,
  className,
  onContextMenu,
}: WsTypographyProps) => (
  <Tooltip title={hoverText ? hoverText : ''}>
    <Typography
      variant={variant}
      onClick={onClick}
      className={className}
      color={mapColor.get(color)}
      onContextMenu={onContextMenu}
      sx={{
        opacity: opacity ? '65%' : '100%',
        cursor: cursor ? cursor : 'text',
        display: display ? display : 'block',
        fontWeight: bold ? 700 : 500,
      }}
    >
      {children}
    </Typography>
  </Tooltip>
);
export default WsTypography;
